
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proposals/get-a-proposal",
      function () {
        return require("private-next-pages/proposals/get-a-proposal/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proposals/get-a-proposal"])
      });
    }
  